import React, { useState } from "react";

const Navbar = () => {
  const [dropdown, setDropdown] = useState(null);

  const toggleDropdown = (menu) => {
    setDropdown(dropdown === menu ? null : menu);
  };

  return (
    <nav className="bg-gray-50 shadow-md w-full">
      <div className="container mx-auto px-4 flex flex-col items-center">
        {/* Navigation Links */}
        <div className="w-full">
          <ul className="flex justify-center items-center text-gray-700">
            {/* Home */}
            <li className="relative group">
              <button className="hover:text-red-600 cursor-pointer text-xl p-2" aria-label="Home">
                <i className="fas fa-home"></i>
              </button>
            </li>
            {/* About */}
            <li
              className="relative group"
              onMouseEnter={() => toggleDropdown("about")}
              onMouseLeave={() => toggleDropdown(null)}
            >
              <button className="hover:text-red-600 cursor-pointer py-2 px-4 relative">
                About Us
                <span className="absolute left-0 bottom-0 w-0 h-0.5 bg-red-600 group-hover:w-full transition-all"></span>
              </button>
              {dropdown === "about" && (
                <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-48 bg-white shadow-lg rounded-md z-50">
                  <ul className="py-2">
                    <li className="relative hover:text-red-600 cursor-pointer px-4 py-2 hover:bg-gray-100 transition-all hover:pl-6">
                      About TX Hospitals
                      
                    </li>
                    <li className="relative hover:text-red-600 cursor-pointer px-4 py-2 hover:bg-gray-100 transition-all hover:pl-6">
                      Board of Directors
                      
                    </li>
                    <li className="relative hover:text-red-600 cursor-pointer px-4 py-2 hover:bg-gray-100 transition-all hover:pl-6">
                      Management
                      
                    </li>
                    <li className="relative hover:text-red-600 cursor-pointer px-4 py-2 hover:bg-gray-100 transition-all hover:pl-6">
                      Why TX?
                      
                    </li>
                    <li className="relative hover:text-red-600 cursor-pointer px-4 py-2 hover:bg-gray-100 transition-all hover:pl-6">
                      FAQs
                      
                    </li>
                  </ul>
                </div>
              )}
            </li>
            {/* Centre of Excellence */}
            <li
              className="relative group"
              onMouseEnter={() => toggleDropdown("center")}
              onMouseLeave={() => toggleDropdown(null)}
            >
              <button className="hover:text-red-600 cursor-pointer py-2 px-4 relative">
                Centre of Excellence
                <span className="absolute left-0 bottom-0 w-0 h-0.5 bg-red-600 group-hover:w-full transition-all"></span>
              </button>
              {dropdown === "center" && (
                <div className="z-50 absolute top-full left-1/2 transform -translate-x-1/2 w-auto bg-white shadow-lg rounded-md border border-gray-200">
                <ul
                  // className="grid grid-cols-3 divide-x divide-gray-200"
                  className="grid grid-cols-2 gap-x-6 gap-y-2 text-sm p-4"
                  style={{ gridTemplateColumns: "auto auto auto" }}
                >
                  <li className="hover:text-red-600 cursor-pointer px-4 py-2 hover:bg-gray-100 border-b hover:pl-6 transition-all">Cardiac Sciences</li>
                  <li className="hover:text-red-600 cursor-pointer px-4 py-2 hover:bg-gray-100 border-b hover:pl-6 transition-all">Gastro Sciences</li>
                  <li className="hover:text-red-600 cursor-pointer px-4 py-2 hover:bg-gray-100 border-b hover:pl-6 transition-all">Renal Sciences</li>
                  <li className="hover:text-red-600 cursor-pointer px-4 py-2 hover:bg-gray-100 border-b hover:pl-6 transition-all">Pulmonology</li>
                  <li className="hover:text-red-600 cursor-pointer px-4 py-2 hover:bg-gray-100 border-b hover:pl-6 transition-all">ENT</li>
                  <li className="hover:text-red-600 cursor-pointer px-4 py-2 hover:bg-gray-100 border-b hover:pl-6 transition-all">Eye / Ophthalmology</li>
                  <li className="hover:text-red-600 cursor-pointer px-4 py-2 hover:bg-gray-100 border-b hover:pl-6 transition-all">Mother & Child Care</li>
                  <li className="hover:text-red-600 cursor-pointer px-4 py-2 hover:bg-gray-100 border-b hover:pl-6 transition-all">Dermatology & Cosmetic Care</li>
                  <li className="hover:text-red-600 cursor-pointer px-4 py-2 hover:bg-gray-100 border-b hover:pl-6 transition-all">Neuro Sciences</li>
                  <li className="hover:text-red-600 cursor-pointer px-4 py-2 hover:bg-gray-100 border-b hover:pl-6 transition-all">Oncology</li>
                  <li className="hover:text-red-600 cursor-pointer px-4 py-2 hover:bg-gray-100 border-b hover:pl-6 transition-all">Orthopaedics & Rheumatology</li>
                  <li className="hover:text-red-600 cursor-pointer px-4 py-2 hover:bg-gray-100 border-b hover:pl-6 transition-all">Transplant Medicine</li>
                  <li className="hover:text-red-600 cursor-pointer px-4 py-2 hover:bg-gray-100 border-b hover:pl-6 transition-all">Endocrinology</li>
                  <li className="hover:text-red-600 cursor-pointer px-4 py-2 hover:bg-gray-100 border-b hover:pl-6 transition-all">Robotic Sciences</li>
                  <li className="hover:text-red-600 cursor-pointer px-4 py-2 hover:bg-gray-100 border-b hover:pl-6 transition-all">Dental & Maxillofacial</li>
                  <li className="hover:text-red-600 cursor-pointer px-4 py-2 hover:bg-gray-100 border-b hover:pl-6 transition-all">Anaesthesia & Pain Management</li>
                  <li className="hover:text-red-600 cursor-pointer px-4 py-2 hover:bg-gray-100 border-b hover:pl-6 transition-all">Emergency & Critical Care</li>
                  <li className="hover:text-red-600 cursor-pointer px-4 py-2 hover:bg-gray-100 border-b hover:pl-6 transition-all">Dietetics</li>
                  <li className="hover:text-red-600 cursor-pointer px-4 py-2 hover:bg-gray-100 border-b hover:pl-6 transition-all">General Surgery</li>
                </ul>
              </div>
              )}
            </li>
            {/* Doctors */}
            <li
              className="relative group"
              onMouseEnter={() => toggleDropdown("doctor")}
              onMouseLeave={() => toggleDropdown(null)}
            >
              <button className="py-2 px-4 hover:text-red-600 cursor-pointer relative">
                Doctors
                <span className="absolute left-0 bottom-0 w-0 h-0.5 bg-red-600 group-hover:w-full transition-all"></span>
              </button>
              {dropdown === "doctor" && (
                <div className="z-50 absolute top-full left-1/2 transform -translate-x-1/2 w-48 bg-white shadow-lg rounded-md">
                  <ul className="py-2">
                    <li className="relative hover:text-red-600 cursor-pointer px-4 py-2 hover:bg-gray-100 transition-all hover:pl-6">
                      Doctor-1
                      
                    </li>
                    <li className="relative hover:text-red-600 cursor-pointer px-4 py-2 hover:bg-gray-100 transition-all hover:pl-6">
                      Doctor-2
                      
                    </li>
                  </ul>
                </div>
              )}
            </li>
            {/* Blogs */}
            <li
              className="relative group"
              onMouseEnter={() => toggleDropdown("blog")}
              onMouseLeave={() => toggleDropdown(null)}
            >
              <button className="py-2 px-4 hover:text-red-600 cursor-pointer relative">
                Blogs
                <span className="absolute left-0 bottom-0 w-0 h-0.5 bg-red-600 group-hover:w-full transition-all"></span>
              </button>
              {dropdown === "blog" && (
                <div className="z-50 absolute top-full left-1/2 transform -translate-x-1/2 w-48 bg-white shadow-lg rounded-md">
                  <ul className="py-2">
                    <li className="relative hover:text-red-600 cursor-pointer px-4 py-2 hover:bg-gray-100 transition-all hover:pl-6">
                      Blog Post-1
                      
                    </li>
                    <li className="relative hover:text-red-600 cursor-pointer px-4 py-2 hover:bg-gray-100 transition-all hover:pl-6">
                      Blog Post-2
                      
                    </li>
                  </ul>
                </div>
              )}
            </li>
            {/* News & Media */}
            <li
              className="relative group"
              onMouseEnter={() => toggleDropdown("news")}
              onMouseLeave={() => toggleDropdown(null)}
            >
              <button className="py-2 px-4 hover:text-red-600 cursor-pointer relative">
                News & Media
                <span className="absolute left-0 bottom-0 w-0 h-0.5 bg-red-600 group-hover:w-full transition-all"></span>
              </button>
              {dropdown === "news" && (
                <div className="z-50 absolute top-full left-1/2 transform -translate-x-1/2 w-48 bg-white shadow-lg rounded-md">
                  <ul className="py-2">
                    <li className="relative hover:text-red-600 cursor-pointer px-4 py-2 hover:bg-gray-100 transition-all hover:pl-6">
                      News
                      
                    </li>
                    <li className="relative hover:text-red-600 cursor-pointer px-4 py-2 hover:bg-gray-100 transition-all hover:pl-6">
                      Media
                      
                    </li>
                  </ul>
                </div>
              )}
            </li>
            {/* Contact Us */}
            <li
              className="relative group"
              onMouseEnter={() => toggleDropdown("contact")}
              onMouseLeave={() => toggleDropdown(null)}
            >
              <button className="py-2 px-4 hover:text-red-600 cursor-pointer relative">
                Contact Us
                <span className="absolute left-0 bottom-0 w-0 h-0.5 bg-red-600 group-hover:w-full transition-all"></span>
              </button>
              {dropdown === "contact" && (
                <div className="z-50 absolute top-full left-1/2 transform -translate-x-1/2 w-48 bg-white shadow-lg rounded-md">
                  <ul className="py-2">
                    <li className="relative hover:text-red-600 cursor-pointer px-4 py-2 hover:bg-gray-100 transition-all hover:pl-6">
                      Mobile
                      
                    </li>
                    <li className="relative hover:text-red-600 cursor-pointer px-4 py-2 hover:bg-gray-100 transition-all hover:pl-6">
                      Gmail
                      
                    </li>
                  </ul>
                </div>
              )}
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
